import { useEffect, useState } from 'react';
import { listStorageNodes } from '../../clients/storage_client';
import { logInfo } from '../../config_and_helpers/logger';

const LOG_CONTEXT = 'useLabStorageNodes';

/**
 * Load the lab storage tree while a modal is open. `ready` is false until the
 * request finishes, and also when the API is missing, so lot forms do not send
 * a place the server cannot store.
 *
 * @param {string|null|undefined} token
 * @param {boolean} active
 * @returns {{ nodes: Array, ready: boolean }}
 */
export function useLabStorageNodes(token, active) {
  const [nodes, setNodes] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!active || !token) {
      setNodes([]);
      setReady(false);
      return undefined;
    }
    let cancelled = false;
    setReady(false);
    listStorageNodes(token).then(result => {
      if (cancelled) return;
      const loaded = result.success ? result.data || [] : [];
      setNodes(loaded);
      setReady(Boolean(result.success));
      logInfo(LOG_CONTEXT, 'storage tree for inventory', {
        ready: Boolean(result.success),
        nodeCount: loaded.length,
        status: result.status ?? null,
      });
    });
    return () => {
      cancelled = true;
    };
  }, [token, active]);

  return { nodes, ready };
}
